<template>
  <v-menu offset-y
          nudge-left="80"
          :close-on-content-click="false"
          :nudge-width="100"
          transition="slide-y-transition">
    <v-btn slot="activator"
           small
           class="text-shadow"
           flat>
      {{ currentCity.alias }}
    </v-btn>

    <v-list>
      <template v-for='item in cities'>
        <v-list-tile v-if="currentCity.code !== item.code"
                     :key='item.code'
                     class="primary--text"
                     :href="item.web">
          <v-list-tile-title>
            {{ item.alias }}
          </v-list-tile-title>
        </v-list-tile>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import store from '@/store';

export default {
  name: 'CitySelector',
  computed: {
    // langsFiltered() {
    //   return _.filter(this.items, it => {
    //     return it.langName !== store.state.langSelected.langName;
    //   });
    // },
    currentCity() {
      return store.state.citySelected
    }
  },
  // countrySelected(val) {
  //   val && this.changeCountry(val);
  // },
  data() {
    return {
      cities: store.state.citiesArray
    };
  }
};
</script>
